import { Dispatch } from 'redux'
import { EntityParams } from 'app/models/entity-params'
import {
  activateEntity,
  removeEntities,
  deactivateEntity,
} from 'app/state/ducks/entities/thunks'
import {
  ErrorNotification,
  SuccessNotification,
} from 'app/views/components/notifications/notification'
import { cleanErrorMessage } from 'app/utils/util-functions'

export async function activeEntity(
  entity: Pick<EntityParams, 'id'>,
  dispatch: Dispatch<any>
) {
  const response: any = await dispatch(activateEntity(entity))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Activated',
      message: 'Entity has been Activated',
    })
  } else {
    ErrorNotification({
      title: 'Approval Failed',
      message: cleanErrorMessage(response.payload) || 'Error with activation',
    })
    return false
  }
  return true
}

export async function makeInactiveEntity(
  entity: Pick<EntityParams, 'id'>,
  dispatch: Dispatch<any>
) {
  const response: any = await dispatch(deactivateEntity(entity))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Deactivation',
      message: 'Entity has been deactivated.',
    })
  } else {
    ErrorNotification({
      title: 'Deactivation Failed',
      message: response.payload || 'Error with deactivation',
    })
    return false
  }
  return true
}

export async function deleteEntity(
  entity: Pick<EntityParams, 'id'>,
  dispatch: Dispatch<any>
) {
  // the thunk's own error handler throws on an answer with no response
  const response: any = await Promise.resolve(dispatch(removeEntities([entity.id]))).catch(
    () => undefined
  )
  // The delete answers per id ({ id, isSuccess, error }), with HTTP 200 even
  // when the ledger refused it; a failed request answers { success: false }.
  const results = Array.isArray(response?.payload) ? response.payload : null
  const refused = results?.find((result: any) => result?.isSuccess === false || result?.error)
  if (!results || response?.success === false || refused) {
    const reason = refused?.error ?? response?.payload
    ErrorNotification({
      title: 'Delete Failed',
      message:
        (typeof reason === 'string' ? cleanErrorMessage(reason) : reason?.message) ||
        'Error with deletion',
    })
    return false
  }
  SuccessNotification({
    title: 'Successful Deletion',
    message: 'Entity has been Deleted',
  })
  return true
}
